import React, { createContext, useRef, useState } from 'react'

export const GoogleAdContext = createContext()

export const GoogleAdProvider = ({ children }) => {
  const pushedAds = useRef(new Set())
  const [previousRoute, setPreviousRoute] = useState(null)

  return (
    <GoogleAdContext.Provider value={{ pushedAds, previousRoute, setPreviousRoute }}>
      {children}
    </GoogleAdContext.Provider>
  )
}
